import { JobsList } from './jobs-list/JobsList';
import { DraftsList } from './jobs-list/DraftsList';
import { TemplatesList } from './jobs-list/templates/TemplatesList';
import { useAppConfigContext } from '@/app/core';
import { useSetPageTitle } from '@/app/store';
import { parse as qsParse } from 'qs';
import { useLocation } from 'react-router-dom';
import { TabProps, Tabs } from '@ssar-app/uikit';
import { useState } from 'react';
import { FeatureCodes } from '@ssar-app/domain';

export const DashboardPage = () => {
  const location = useLocation();
  const params = qsParse((location.search || '').replace(/^\?/, ''));
  const tabKeys = ['jobs', 'drafts', 'templates'];
  const [activeTab, setActiveTab] = useState<string>(
    params?.show?.toString() || 'jobs',
  );
  useSetPageTitle('Dashboard');
  const handleTabChange = (activeKey: string): void => setActiveTab(activeKey);
  const { getCurrentFeature } = useAppConfigContext();
  const feature = getCurrentFeature();

  const canViewTemplates = feature?.code === FeatureCodes.AscendQuest;
  const prepareTabs = (): TabProps[] => {
    const tabs: TabProps[] = [];
    if (feature) {
      tabs.push({
        label: 'Jobs',
        key: tabKeys[0],
        content: <JobsList activeTab={activeTab} feature={feature} />,
      });
      tabs.push({
        label: 'Drafts',
        key: tabKeys[1],
        content: <DraftsList feature={feature} />,
      });
    }
    if (feature && canViewTemplates) {
      tabs.push({
        label: 'Templates',
        key: tabKeys[2],
        content: <TemplatesList activeTab={activeTab} feature={feature} />,
      });
    }
    return tabs;
  };

  return (
    <Tabs
      defaultIndex={tabKeys.indexOf(activeTab) || 0}
      variant='line'
      items={prepareTabs()}
      onChange={handleTabChange}
      tabListProps={{ borderColor: 'gray.500' }}
      tabProps={{ h: 10 }}
      tabPanelProps={{ px: 0 }}
      mt={2}
    />
  );
};
